import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { SM, MD, LG } from '@/utils/breakpointUtils';

import IconSearch from '@/assets/icons/search.svg?inline';
import IconCross from '@/assets/icons/cross.svg?inline';

const LargeSearchBarProps = Vue.extend({
  props: {
    placeHolder: { type: String, default: 'Search by name, expertise or destination…' },
    searchValue: { type: String, default: null },
    hasFocus: { type: Boolean, default: false },
    getHintsOnInput: { type: Boolean, default: false },
  },
});

@Component({
  components: {
    IconSearch,
    IconCross,
  },
})
export default class LargeSearchBar extends LargeSearchBarProps {
  searchData = this.searchValue;
  hasFocusData = false;

  IsNav() {
    return document.querySelector('.is-search-active');
  }

  handleSearchSubmit() {
    if (this.searchData?.trimEnd().trimStart().length > 3)
      if (this.IsNav()) {
        document.location.href = `/search?q=${this.searchData
          .trimEnd()
          .trimStart()
          .replace(/\s+/g, '+')}`;
      } else {
        history.pushState({}, null, `/search?q=${this.searchData}`);
        this.$emit('searchdata', this.searchData);
      }
  }

  handleClearSearch() {
    this.searchData = '';
    this.$emit('cleardata');
  }

  get UID() {
    return this.uuid;
  }

  get responsivePlaceholder() {
    if (window.innerWidth <= SM) {
      return '';
    }
    return this.placeHolder;
  }

  @Watch('hasFocus')
  onFocusPropChange(newVal: boolean, oldVal: boolean) {
    let searchInput = <HTMLInputElement>this.$refs.inputelement;
    if (newVal !== oldVal && newVal !== this.hasFocusData) {
      if (newVal === true) {
        searchInput.focus();
      } else {
        searchInput.blur();
      }
    }
  }

  @Watch('searchValue')
  onSearchValueChange(newVal: string, oldVal: string) {
    this.searchData = newVal;
  }

  @Watch('searchData')
  onSearchDataChange(newVal: string, oldVal: string) {
    if (
      this.getHintsOnInput &&
      newVal !== oldVal &&
      this.searchData?.trimEnd().trimStart().length > 1
    ) {
      this.$emit('searchdata', this.searchData);
    }
    if (!this.searchData?.trimEnd().trimStart()) this.$emit('searchdata', '');
  }
}
